import { render, staticRenderFns } from "./ReportVarieta.vue?vue&type=template&id=e42efd66"
import script from "./ReportVarieta.vue?vue&type=script&lang=js"
export * from "./ReportVarieta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports